import Box from '@mui/material/Box';

export default function TwoCol({
  left,
  right,
  ratio = '1fr 1fr',
  gap = { xs: 6, md: 10 },
  alignItems = 'start',
  reverse = false,
  sx = {},
}) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: ratio },
        gap,
        alignItems,
        ...(reverse && { direction: { md: 'rtl' }, '& > *': { direction: 'ltr' } }),
        ...sx,
      }}
    >
      {left}
      {right}
    </Box>
  );
}
